<template>
    <div class="panel">
        <transition name="slide" appear>
            <div class="row">
                <div v-for="button in buttons" class="button-image-container">
                    <img :id="button.id" :src="button.image" @mouseover="doHoverState(button, 'hover')" @mouseout="doHoverState(button, '')" @click="handleClick(button)" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import response from '@/stores/response.js'

    export default {
        name: 'Changes_panel',
        created: function () {
            var self = this;
            CodeBaby.jQuery('.codebaby-stt-button:visible').hide();
            CodeBaby.jQuery('.no-nlp').hide();
        },
        data: function () {
            return {
                buttons: [
                    {
                        text: "Yes",
                        id: "yes-image",
                        image: require("@/assets/images/yes-button.png"),
                        image_hover: require("@/assets/images/yes-button_hover.png")
                    },
                    {
                        text: "No",
                        id: "no-image",
                        image: require("@/assets/images/no-button.png"),
                        image_hover: require("@/assets/images/no-button_hover.png")
                    }
                ],
                response: response
            };
        },
        methods: {
            doHoverState: function (button, state) {
                var newState = (state == 'hover') ? button.image_hover : button.image;
                CodeBaby.jQuery("#" + button.id).attr({src: newState});
            },
            handleClick: function(button) {
                this.response[(this.$parent.panelState.curPanel)].answer = button.text;
                this.$parent.nextPanel();
            }
        }
    }
</script>
<style scoped lang="stylus">
.panel
    text-align: center
    background-color: #ccc !important
    .button-image-container
        top: 35%
        position: relative
        padding: 10px 0
    .slide-enter, .slide-leave-to
        transform: translateY(-100%)
    .slide-leave-active, .slide-enter-active
        transition: 1s
</style>